import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

const AdminDashboard = () => {
  const [stats, setStats] = useState({ contact: 0, hr: 0, news: 0, gallery: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const headers = { withCredentials: true };
        const url = process.env.REACT_APP_BACKEND_URL;
        
        const [contactRes, hrRes, newsRes, galRes] = await Promise.all([
          axios.get(`${url}/api/contact`, headers),
          axios.get(`${url}/api/hr-applications`, headers),
          axios.get(`${url}/api/news`),
          axios.get(`${url}/api/gallery`)
        ]);

        setStats({
          contact: contactRes.data.length,
          hr: hrRes.data.length,
          news: newsRes.data.length,
          gallery: galRes.data.length,
        });
      } catch (err) {
        console.error("Error fetching stats", err);
      }
    };
    fetchStats();
  }, []);

  const cards = [
    { title: 'Okunmamış Mesajlar (İletişim)', value: stats.contact, color: 'bg-blue-50 text-blue-600' },
    { title: 'İK Başvuruları', value: stats.hr, color: 'bg-indigo-50 text-indigo-600' },
    { title: 'Yayınlanan Haberler', value: stats.news, color: 'bg-emerald-50 text-emerald-600' },
    { title: 'Galeri Görselleri', value: stats.gallery, color: 'bg-amber-50 text-amber-600' }
  ];

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card, i) => (
          <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
            <h3 className="text-slate-500 text-sm font-medium mb-4">{card.title}</h3>
            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-2xl font-bold ${card.color}`}>
              {card.value}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
        <h2 className="text-xl font-bold text-slate-800 mb-4">Sisteme Hoş Geldiniz</h2>
        <p className="text-slate-600">
          Sol taraftaki menüyü kullanarak web sitenizin içeriklerini yönetebilir, 
          gelen insan kaynakları başvurularını inceleyebilir ve iletişim mesajlarına erişebilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default AdminDashboard;
